import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import { InvalidCargoModel } from "../../InvalidCheck/models/InvalidCargoModel";
import { CargoInputModel } from "../models/CargoInputModel";
import CargoModel from "../models/CargoModel";
import CargoQueryModel from "../models/CargoQueryModel";

export interface SearchCargoParam {
    pageSize: number,
    query: CargoQueryModel
}

export interface GetCargoByIdParam {
    id: string,
}

export interface DeleteDuplicateCargosParam {
    ids: string[],
}

export interface CorrectInvalidCargoParam {
    id: string,
    charterer: string,
    cargoType: number,
    loadPort: number,
    disport: number
}

export interface ParseFullOrderParam {
    fullOrder: string
}

const CargoApi = {
    Search(param: SearchCargoParam) {
        return Api.post<SearchCargoParam, BaseResponse<CargoModel[]>>("/api/cargo/Search", param);
    },
    Save(param: CargoInputModel) {
        return Api.post<CargoInputModel, BaseResponse<CargoModel>>("/api/cargo/Save", param);
    },
    GetById(param: GetCargoByIdParam) {
        return Api.get<GetCargoByIdParam, BaseResponse<CargoModel>>("/api/cargo/GetById", param);
    },
    GetDuplicateCargos() {
        return Api.get<null, BaseResponse<CargoModel[]>>("/api/cargo/GetDuplicateCargos", null);
    },
    DeleteDuplicateCargos(param: DeleteDuplicateCargosParam) {
        return Api.post<DeleteDuplicateCargosParam, BaseResponse<CargoModel[]>>("/api/cargo/DeleteDuplicateCargos", param);
    },
    GetInvalidCargos() {
        return Api.get<null, BaseResponse<InvalidCargoModel[]>>("/api/cargo/GetInvalidCargos", null);
    },
    CorrectInvalid(param: CorrectInvalidCargoParam) {
        return Api.post<CorrectInvalidCargoParam, BaseResponse<CargoModel>>("/api/cargo/CorrectInvalid", param);
    },
    ParseFullOrder(param: ParseFullOrderParam) {
        return Api.post<ParseFullOrderParam, BaseResponse<CargoModel>>("/api/cargo/ParseFullOrder", param);
    },
};
export default CargoApi;